import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = [
        'breadcrumb',
        'expandable',
        'placeholder',
        'collapsedTemplate',
        'homeElementTemplate',
        'elementTemplate',
        'separatorTemplate',
    ];

    static outlets = ['header--mobile'];

    connect() {
        this.items = [];
    }

    update(event) {
        this.resetBreadcrumb();

        if (!this.headerMobileOutlet.isMobileView || !this.headerMobileOutlet.menuOpenValue) {
            return;
        }

        const items = this.createHierarchy(event);

        const length = items.length;
        if (!length) {
            return;
        }

        this.breadcrumbTarget.appendChild(this.separatorTemplateTarget.content.cloneNode(true));

        items.forEach((item, index) => {
            const element = this.elementTemplateTarget.content.cloneNode(true);
            element.children[0].textContent = item.getAttribute('data-menu-label');

            if (length > 1 && index < length - 1) {
                element.children[0].textContent = item.getAttribute('data-menu-label');
                element.children[0].classList.add('tw-hidden');

                this.breadcrumbTarget.appendChild(this.collapsedTemplateTarget.content.cloneNode(true));
            }

            this.breadcrumbTarget.appendChild(element);

            if (index < length - 1) {
                this.breadcrumbTarget.appendChild(this.separatorTemplateTarget.content.cloneNode(true));
            }
        });
    }

    expandItems() {
        this.placeholderTargets.forEach((item) => {
            item.classList.add('tw-hidden');
        });

        this.expandableTargets.forEach((item) => {
            item.classList.remove('tw-hidden');
        });
    }

    resetBreadcrumb() {
        this.breadcrumbTarget.innerHTML = '';

        this.breadcrumbTarget.appendChild(this.homeElementTemplateTarget.content.cloneNode(true));
    }

    createHierarchy({ target, detail }) {
        const items = detail.open ? [target] : [];

        let currentElement = target;
        // eslint-disable-next-line no-cond-assign
        while (currentElement = currentElement.closest(`[data-menu-item]:not([data-menu-item="${currentElement.dataset.menuItem}"])`)) {
            items.push(currentElement);
        }

        return items.reverse();
    }
}
